import { render } from "./TestPage.vue?vue&type=template&id=023299e8"
import script from "./TestPage.vue?vue&type=script&lang=ts"
export * from "./TestPage.vue?vue&type=script&lang=ts"
script.render = render

export default script